import {pushEdapEvent} from '../../utils/edap';

export function onViewMoreOrLessClick(isExpanded) {
    pushEdapEvent('generic.event', {
        actionlocation: 'collapsible-paragraph',
        eventcategory: 'interaction-click',
        eventaction: isExpanded ? 'expand' : 'collapse',
        eventrefinements: 'DEST_INTRO',
    });

    pushEdapEvent('interaction.selected', {
        action_location: 'collapsible-paragraph',
        event_category: 'interaction-click',
        event_action: isExpanded ? 'expand' : 'collapse',
        event_refinements: 'DEST_INTRO',
    });
}

export default onViewMoreOrLessClick;
